export enum ItemCategory {
    FOOD = "FOOD",
    COLDDRINKS = "COLDDRINKS",
    HOTDRINKS = "HOTDRINKS",
    SNACKS = "SNACKS",
    VOUCHERS = "VOUCHERS",
    MISC = "MISC"
}

export class ItemContainer {
    constructor(public item: Item, public quantity = 0) {}
}

export class Item {
    constructor(public id: string = "", public category: ItemCategory = ItemCategory.MISC,
                public name: string = "Neuer Artikel",
                public defaultPrice: number = 0, public vatRate: number = 0,
                public groupPrices: Map<string, number> = new Map<string, number>()) {}
}

export function itemFromRaw(raw: any): Item {
    const groupPrices = mapFromRawGroupPrices(raw?.groupPrices)
    const category = parseCategory(raw?.category)
    return new Item(raw?.id ?? "", category, raw?.name ?? "Neuer Artikel",
        raw?.defaultPrice ?? 0, raw?.vatRate ?? 0, groupPrices)
}

export function itemToRaw(item: Item) {
    return {
        ...item,
        groupPrices: Object.fromEntries(item.groupPrices)
    }
}

function mapFromRawGroupPrices(rawGroupPrices: any): Map<string, number> {
    if (rawGroupPrices instanceof Map) return rawGroupPrices
    const obj = rawGroupPrices && typeof rawGroupPrices === "object" ? rawGroupPrices : {}
    const entries = Object.entries(obj)
        .map(([k, v]) => [k, Number(v)] as [string, number])
        .filter(([, v]) => !isNaN(v))
    return new Map<string, number>(entries)
}

function parseCategory(category: any): ItemCategory {
    if (category && typeof category === "string" && category in ItemCategory) {
        return ItemCategory[category as keyof typeof ItemCategory]
    }
    return ItemCategory.MISC
}
